import { Image, Modal, Progress } from "antd";
import GradientButton from "../../../component/common/GradientButton";
import teamC from "../../../asset/image/Group 22.svg"; // Adjust the path as necessary
import { useNavigate } from "react-router-dom";
import { appRoot } from "../../../util/constant/CONSTANTS";

const ProgressModal = ({
  openSuccessModal = null,
  onClose = () => {},
  progress = 0, // Default progress value
}) => {
  const navigate = useNavigate();

  return (
    <Modal
      open={openSuccessModal !== null}
      closeIcon={false}
      footer={null}
      centered
      onCancel={() => onClose()}
      maskClosable={false}
      style={{ zoom: 0.9 }}
      width={500}
      className="rounded-[40px] overflow-hidden p-0 auth-modal"
      styles={{
        content: { padding: 0 },
        body: { padding: "50px" },
        mask: { backgroundColor: "rgba(0, 0, 0, 0.8)" },
      }}
    >
      {openSuccessModal === "success" && (
        <div className="mobilescale">
          <div className="flex flex-col mb-[50px]">
            <div className="flex justify-center">
              <Image src={teamC} width={90} preview={false} />
            </div>
            <div className="text-4xl font-semibold text-center mt-[30px]">
              Post Uploaded
            </div>
            <div className="text-lg text-[#6B7280] text-center mt-2">
              Post upload completed successfully, and all selected teams have
              been updated.
            </div>
          </div>
          <GradientButton
            className="w-full"
            buttonText="Go To Team Management"
            onClick={() => {
              onClose();
              navigate(appRoot);
            }}
          />
        </div>
      )}
      {openSuccessModal === "progress" && (
        <div className="mobilescale">
          <div className="flex flex-col mb-3">
            <div className="text-4xl font-semibold text-center mb-10">
              Post Uploading...
            </div>
            <div className="flex justify-center">
              <Progress
                type="circle"
                percent={progress}
                strokeColor="#A855F7"
                size={200}
              />
            </div>
            <div className="text-lg text-[#6B7280] text-center mt-5">
              Your posts are being uploaded. This may take a few minutes.
            </div>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default ProgressModal;
